/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfigTwitchFromJSON, FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfigTwitchToJSON, } from './FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfigTwitch';
import { FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfigFacebookFromJSON, FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfigFacebookToJSON, } from './FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfigFacebook';
import { FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfigFacebookInstantGamesFromJSON, FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfigFacebookInstantGamesToJSON, } from './FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfigFacebookInstantGames';
import { FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfigGoogleFromJSON, FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfigGoogleToJSON, } from './FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfigGoogle';
import { FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfigMyGamesFromJSON, FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfigMyGamesToJSON, } from './FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfigMyGames';
/**
 * Check if a given object implements the FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfig interface.
 */
export function instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsAuthConfig(value) {
    if (!('AllowedAuthProviders' in value) || value['AllowedAuthProviders'] === undefined)
        return false;
    return true;
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfigFromJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfigFromJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfigFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'AllowedAuthProviders': json['AllowedAuthProviders'],
        'Google': json['Google'] == null ? undefined : FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfigGoogleFromJSON(json['Google']),
        'Facebook': json['Facebook'] == null ? undefined : FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfigFacebookFromJSON(json['Facebook']),
        'FacebookInstantGames': json['FacebookInstantGames'] == null ? undefined : FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfigFacebookInstantGamesFromJSON(json['FacebookInstantGames']),
        'MyGames': json['MyGames'] == null ? undefined : FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfigMyGamesFromJSON(json['MyGames']),
        'Twitch': json['Twitch'] == null ? undefined : FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfigTwitchFromJSON(json['Twitch']),
    };
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfigToJSON(json) {
    return FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfigToJSONTyped(json, false);
}
export function FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfigToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'AllowedAuthProviders': value['AllowedAuthProviders'],
        'Google': FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfigGoogleToJSON(value['Google']),
        'Facebook': FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfigFacebookToJSON(value['Facebook']),
        'FacebookInstantGames': FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfigFacebookInstantGamesToJSON(value['FacebookInstantGames']),
        'MyGames': FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfigMyGamesToJSON(value['MyGames']),
        'Twitch': FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfigTwitchToJSON(value['Twitch']),
    };
}
//# sourceMappingURL=FxIdDomainSettingsPublicWebClientConfigOptionsAuthConfig.js.map